<ng-container *ngIf="picklist?.id; else noPicklistRoute">
  <a [routerLink]="'/shipping/picklists/' + picklist?.id" target="_blank">
    <mat-chip *ngIf="statusDisplay" class="lum-chip lum-chip--small" disableRipple>
      <mat-icon class="ag-status-circle {{ colorClass }} mr-2"></mat-icon>
      {{ statusDisplay | capitalize: true }}
    </mat-chip>
  </a>
</ng-container>
<ng-template #noPicklistRoute>
  <mat-chip
    *ngIf="statusDisplay"
    class="lum-chip lum-chip--small lum-noclick"
    disableRipple
  >
    <mat-icon class="ag-status-circle {{ colorClass }} mr-2"></mat-icon>
    {{ statusDisplay | capitalize: true }}
  </mat-chip>
</ng-template>
